// extracted by mini-css-extract-plugin
export default {"UsersInfoPanel":"CompanyBalanceCreatePanel_UsersInfoPanel__2pvet","buttonsPanel":"CompanyBalanceCreatePanel_buttonsPanel__hzbuP"};